export default class AdminAulaForm {
    /**
     *
     * @param {string} data.empresaId
     * @param {string} data.empresaNombre
     */
    constructor(data) {
        for (let attr in data) {
            this[attr] = data[attr];
        }

        this.otraSeccion = "Otra sección";
    }

    /**
     *
     * @param {callback} options.onSuccess
     */
    nuevo(options) {
        let myself = this;
        let modalOpts = {
            title: "Nueva aula - " + myself.empresaNombre,
            method: "POST",
            url: "/api/admin/aulas",
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    },
                },
            };
        }
        this.modal = new FormModal(modalOpts);
        let data = {
            nombre: "",
            url: "",
        };
        this.modal.render(this.render(data), function () {
            myself.onInitForm();
        });
    }

    /**
     * @param {number} id
     * @param {callback} options.onSuccess
     */
    editar(id, options) {
        let myself = this;
        let modalOpts = {
            title: "Editar aula - " + myself.empresaNombre,
            method: "PUT",
            url: `/api/admin/aulas/${id}`,
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    },
                },
            };
        }
        this.modal = new FormModal(modalOpts);
        Ajax.get(`/api/admin/aulas/${id}`, {
            then: function (response) {
                myself.modal.render(myself.render(response.data), function () {
                    myself.onInitForm();
                });
            },
        });
    }

    onInitForm() {
        let myself = this;
        let modalBody = document.querySelector(".bootbox-body");
        let txtSeccion = modalBody.querySelector("#seccion");
        let cbSeccion = modalBody.querySelector("#secciones");

        myself.determinarSelectSecciones(
            cbSeccion.value,
            txtSeccion.value,
            txtSeccion
        );

        $(modalBody.querySelector("#secciones")).change(function () {
            myself.determinarSelectSecciones(this.value, "", txtSeccion);
        });
    }

    determinarSelectSecciones(value, trueValue, txtSeccion) {
        if (value == this.otraSeccion) {
            txtSeccion.value = trueValue;
            txtSeccion.classList.remove("d-none");
        } else {
            txtSeccion.value = value;
            txtSeccion.classList.add("d-none");
        }
    }

    render(data) {
        let myself = this;
        let anhos = [];
        const anhoActual = new Date().getFullYear();
        for (let a = anhoActual; a >= 2022; a--) {
            anhos.push({ id: a, nombre: a });
        }
        const optActivas = [
            { id: 1, nombre: "Sí" },
            { id: 0, nombre: "No" },
        ];

        let valueDocenteIds = [];
        if (data.aula_docentes != undefined) {
            data.aula_docentes.forEach((adoc) => {
                valueDocenteIds.push(adoc.docente_id);
            });
        }
        if (data.seccion === undefined || data.seccion === null) {
            data.seccion = "";
        }
        let seccionValue = data.seccion;
        if (myself.secciones.findIndex((s) => s.nombre == data.seccion) == -1) {
            seccionValue = this.otraSeccion;
        }

        let items = [
            {
                name: "activa",
                text: "Activa",
                value: data.activa || 1,
                attr: "",
                opt: { list: optActivas, nombre: "nombre", id: "id" },
            },
            {
                name: "anho",
                text: "Año",
                value: data.anho || anhoActual,
                attr: "",
                opt: { list: anhos, nombre: "nombre", id: "id" },
            },
            {
                name: "docente_ids[]",
                text: "Docentes",
                value: valueDocenteIds,
                attr: ' multiple="multiple"',
                opt: {
                    list: myself.docentes,
                    nombre: "nombre_completo",
                    id: "id",
                },
            },
            {
                name: "grado",
                text: "Grado",
                value: data.grado || 0,
                attr: "",
                opt: { list: myself.grados, nombre: "nombre", id: "id" },
            },
            {
                name: "secciones",
                text: "Sección",
                value: seccionValue,
                attr: "",
                opt: { list: myself.secciones, nombre: "nombre", id: "nombre" },
            },
        ];

        let html = "";
        items.forEach((item) => {
            let optHtml = "";
            item.opt.list.forEach((o) => {
                let optSelected = "";
                if (typeof item.value == "object") {
                    if (item.value.findIndex((v) => v == o[item.opt.id]) > -1) {
                        optSelected = ' selected="selected"';
                    }
                } else {
                    optSelected =
                        o[item.opt.id] == item.value
                            ? ' selected="selected"'
                            : "";
                }
                optHtml += `<option value="${o[item.opt.id]}" ${optSelected}>${
                    o[item.opt.nombre]
                }</option>`;
            });
            html += `<div class="row form-group my-1">
            <label for="${item.name}" class="col-form-label col col-md-4">${item.text}</label>
            <div class="col col-md-8">
                <select class="form-select form-select-sm" name="${item.name}" id="${item.name}" required ${item.attr}>${optHtml}</select>
            </div>
        </div>`;
        });
        return `<form>
        <input type="hidden" name="empresa_id" value="${this.empresaId}"/>
        ${html}
        <div class="row form-group my-1">
            <label class="col-form-label col col-md-4"></label>
            <div class="col col-md-8">
                <input type="text" name="seccion" id="seccion" value="${data.seccion}" required class="form-control form-control-sm d-none" />
            </div>
        </div>
        </form>`;
    }
}
